import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { CircularProgress, Typography, Box } from "@mui/material"; // Import CircularProgress and Typography from MUI
import { useSelector } from "react-redux";
import { format, parseISO } from "date-fns"; // For date formatting
import configServ from "../../services/config";
import LoaderNew from "../../Components/Loader/LoaderNew";

const BarGraph = () => {
  const [quarterlyInvoiceData, setQuarterlyInvoiceData] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);

  const {
    user_id,
    company_id,
    companyName,
    companyAddress,
    companyState,
    companyCountry,
  } = useSelector((state) => state.GlobalVariables);

  useEffect(() => {
    const fetchInvoiceList = async () => {
      try {
        const dataToSend = {
          company_id: company_id,
          search_by: "invoice_number",
          search: null,
          session: null,
          per_page: 1000,
          page: 0,
          sort_by: "id",
          order: "desc",
        };

        // Make the API call
        const res = await configServ.invoiceListAdmin(dataToSend);
        if (res.status === 200) {
          const result = res.data.map((item, index) => ({
            date: item.date,
          }));
          setInvoiceList(result);
        }
      } catch (e) {
        console.log(e);
      }
    };

    // Call the function to fetch invoice list
    fetchInvoiceList();
  }, []);

  useEffect(() => {
    if (invoiceList && invoiceList.length > 0) {
      const quarterlyData = {};

      // Define a helper function to get the quarter from the date
      const getQuarter = (date) => {
        const month = parseISO(date).getMonth(); // getMonth() returns 0 for January, 1 for February, ..., 11 for December
        if (month < 3) return "Q1";
        if (month < 6) return "Q2";
        if (month < 9) return "Q3";
        return "Q4";
      };

      invoiceList.forEach((invoice) => {
        const date = parseISO(invoice.date);
        const year = format(date, "yyyy");
        const quarter = getQuarter(invoice.date);

        const key = `${quarter} ${year}`;
        quarterlyData[key] = (quarterlyData[key] || 0) + 1; // Count invoices per quarter-year
      });

      // Convert the quarterlyData object into an array
      const dataForGraph = Object.entries(quarterlyData)
        .sort(([a], [b]) => {
          const [quarterA, yearA] = a.split(" ");
          const [quarterB, yearB] = b.split(" ");
          return yearA - yearB || quarterA.localeCompare(quarterB);
        })
        .map(([quarterYear, count]) => ({
          quarter: quarterYear,
          count,
        }));

      setQuarterlyInvoiceData(dataForGraph);
    }
  }, [invoiceList]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{ width: "100%", height: "100vh" }} // Set the full height to center the content vertically
    >
      <Typography variant="h4" gutterBottom>
        Quarterly Invoice Report
      </Typography>

      <div style={{ width: "100%", maxWidth: 700, height: 400 }}>
        {quarterlyInvoiceData.length > 0 ? (
          <BarChart
            xAxis={[
              {
                data: quarterlyInvoiceData.map((data) => data.quarter),
                scaleType: "band", // Set the x-axis type to 'band' for categorical data
                labelPadding: 5,  // Adjust padding if needed
                stroke: '#000',   // Axis line color
                strokeWidth: 1,   // Make the axis line thinner
              },
            ]}
            series={[
              {
                data: quarterlyInvoiceData.map((data) => data.count),
              },
            ]}
            width={500}
            height={400}
          />
        ) : (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height={400}
          >
            <LoaderNew />
          </Box>
        )}
      </div>
    </Box>
  );
};

export default BarGraph;
